import { Link } from 'react-router-dom';
import type { CartItem } from '@/api/types';
import { Alert } from '@/components/common/State';
import { formatWon } from '@/utils/format';
import type { CartController } from './useCart';

interface Props {
  item: CartItem;
  cart: CartController;
  compact?: boolean;
}

export default function CartLineItem({ item, cart, compact }: Props) {
  const { selected, toggle, changeQuantity, remove } = cart;

  return (
    <div className={compact ? 'line-item line-item--compact' : 'line-item'}>
      <input
        type="checkbox"
        checked={selected.includes(item.cartItemId)}
        disabled={!item.orderable}
        onChange={() => toggle(item.cartItemId)}
        style={{ alignSelf: 'flex-start', marginTop: 6 }}
      />
      <img src={item.thumbnailUrl} alt={item.productName} />
      <div className="line-item__body">
        <Link to={`/products/${item.productId}`} style={{ fontWeight: 600 }}>
          {item.productName}
        </Link>
        <p className="muted" style={{ margin: '4px 0 10px', fontSize: 13 }}>
          {item.optionName}
        </p>
        {!item.orderable && <Alert tone="error">{item.unavailableReason}</Alert>}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <div className="qty-control">
            <button
              type="button"
              disabled={item.quantity <= 1 || changeQuantity.isPending}
              onClick={() =>
                changeQuantity.mutate({
                  cartItemId: item.cartItemId,
                  quantity: item.quantity - 1,
                })
              }
            >
              −
            </button>
            <span>{item.quantity}</span>
            <button
              type="button"
              disabled={item.quantity >= item.stockQuantity || changeQuantity.isPending}
              onClick={() =>
                changeQuantity.mutate({
                  cartItemId: item.cartItemId,
                  quantity: item.quantity + 1,
                })
              }
            >
              ＋
            </button>
          </div>
          <strong>{formatWon(item.totalPrice)}</strong>
          <button
            type="button"
            className="btn btn--ghost btn--sm muted"
            onClick={() => remove.mutate(item.cartItemId)}
          >
            삭제
          </button>
        </div>
      </div>
    </div>
  );
}
